export const FEATURE_ROUTE_NAME = {
  PATIENT: 'country-index',
  DOCTOR: 'country-index-doctor',
  CLINIC: 'country-index-clinic',
}
